import React from 'react'

import {type CommonBlockType} from '../../../../../../api'
import {Paper} from '../../../../../../components/ui'
import {BlockWithRequirements} from '../BlockWithRequirements'
import {Subtitle, Title} from '../ui'
import styleClasses from './classes.module.css'

type Props = {
  isSubblock?: boolean
  block: CommonBlockType
}

export function CommonBlock({block, isSubblock}: Props) {
  const {title, subtitle, subblocks} = block

  const content = (
    <div className={styleClasses.commonBlock}>
      {!isSubblock && <Title title={title} />}
      {subtitle && <Subtitle subtitle={subtitle} />}
      <div className={styleClasses.commonBlockSubblocks}>
        {subblocks.map(subblock => (
          <BlockWithRequirements key={subblock.id} block={subblock} isSubblock />
        ))}
      </div>
    </div>
  )

  return isSubblock ? content : <Paper>{content}</Paper>
}
